var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back unselectable",on:{"click":_vm.click}},[_c('div',{staticClass:"iconbutton"},[_c('i',{class:_vm.icon || 'fas fa-angle-left'})])])}
var staticRenderFns = []

export { render, staticRenderFns }